module.exports = __webpack_public_path__ + "img/swap.f316c8dc.svg";